module.exports = __webpack_public_path__ + "img/window.e1f3d537.png";